<template>
    <contentCard :loading="loading">
        <template slot="cardContent">
            <div>
                <v-row justify="center" >
                    <v-col class="text-center col-md-6">
                        <div class="font-weight-bold body-1">
                            Compartir encuesta
                        </div>
                    </v-col>
                </v-row>

                <v-row justify="center">
                    <v-col class="text-left col-md-6 font-weight-bold my-0 py-0">
                        Colaboradores a notificar para llenado de la encuesta
                    </v-col>
                </v-row>
                <v-row justify="center">
                    <v-col class="text-left col-md-6">
                        <p class=" questionnaire-share-subtitles pb-0 mb-0">
                            Los colaboradores seleccionados al momento de crear la encuesta aparecerán 
                            seleccionados por defecto, sin embargo es posible modificar la lista si así
                            lo deseas
                        </p>
                    </v-col>
                </v-row>

                <v-row justify="center">
                    <v-col cols="12" md="6">
                        <v-form ref="form" @submit.prevent="save">
                            <share-form  ref="ShareForm" :values="form" @save="save" :serverErrors="serverErrors" :edit="true" :surveyId="id"></share-form>
                        </v-form>
                    </v-col>

                </v-row>

            </div>

            <v-row justify="center" align="end">
				<v-col cols="12" md="6" class="">
                    <v-row justify="end" class="px-3 py-3">
                        <secondary-button :props="cancelBtnData" class="mr-0 mr-sm-2 mb-3 mb-sm-0"></secondary-button>
                        <primary-button :props="saveBtnData" class=""></primary-button>  
                    </v-row>
				</v-col>
			</v-row>
        </template>
    </contentCard>
</template>

<script>
import ShareForm from "./ShareForm.vue";
import Utils from '../../../../helpers/Utils';
export default {
    components: {
        'share-form': ShareForm,
    },

	data(){
		return {
            id: this.$route.params.id,
            serverErrors: {},
            loading: false,
            form: {
                /**GENERAL INFORMATION */
                name: '',
                instructions: '',
                apply_for: [],
                employees: [],
                /**QUESTIONS */
                questions: [],

                //aux
                businessData: [
                    {
                        businessName: "empresa nombre 1",
                        businessId: 1,
                        loading: false,
                        employees: [],
                        employees_notified: []
                    },
                ]

            },
            cancelBtnData: {
                text: "Cancelar",
                icon: "mdi-close",
                to: "Questionary",
                block:false,
                click: () => {}
            },
            saveBtnData: {
                text: "Compartir",
                icon: "mdi-share-variant-outline",
                click: this.save,
                block:false,
                loading: false,
            },
            snackbarProps: {
                visible: false,
				color: 'success',
				timeout: 3000,
				text: '',
            },
		}
    },
    mounted(){
        window.addEventListener('resize', this.onResize, { passive: true });
        this.onResize();
        this.index();
    },
    watch: {
      
    },
	methods: {
        onResize () {
            
            if(window.innerWidth < 600){
                this.saveBtnData.block = true;
                this.cancelBtnData.block = true;
            }
            else{
                this.saveBtnData.block = false;
                this.cancelBtnData.block = false;
            }
        },
        /**
         * load survey
         */
        index()
        {
            this.loading = true;
            this.$store.state.loading = true;
			this.$api.questionaries.get(this.id)
			.then((response) => {
                this.form = {
                    ...this.form,
                    ...response.data,
                    employees: []
                };

                // this.form.apply_for = response.data.apply_for.map((itm) => {
                //     return {text: itm.name, value: itm.id};
                // });

                for (
                    let j = 0;
                    j < response.data?.employees?.length;
                    j++
                ) {
                    const business = response.data?.employees[j];
                    for (let k = 0; k < business.employees.length; k++) {
                        const employee = business.employees[k];
                        this.form.employees.push({
                            id: employee.id,
                            name: employee.name,
                            email: employee.email,
                            businessId: business.id,
                            businessName: business.name,
                        });
                    }
                }

                // this.$refs.form.reset();
			})
			.catch(error => {
				console.log(error);
			})
			.finally(() => {
				this.loading = false;
                this.$store.state.loading = false;
			})
        },
        
		validate () {
            
           
            //questions list
            if(this.form.questions.length == 0 && this.step == 2){
                this.serverErrors[`questions`] = 'Al menos una preguta';
                this.$refs.form.validate()
                return false;
            }

            for (let index = 0; index < this.form.questions.length; index++) {
                if(this.form.questions[index].type == 'multi'){
                    if(this.form.questions[index].option_list.length == 0){

                        this.serverErrors[`questions.${index}.option_list`] = "Al menos una opción";
                        this.$refs.form.validate()
                        return false;
                    }
                }
            }
            // if(this.form.apply_for.length == 0)
            //     return false;

			return this.$refs.form.validate()
		},

       
        save(){
            // this.saveBtnData.loading = true;
            // this.$store.state.loading = true;

            // console.log(this.processRequest(this.form));
            if(this.validate()){

                let form = JSON.parse(JSON.stringify(this.processRequest(this.form)))
                console.log(JSON.stringify(this.processRequest(this.form)))
                this.$api.questionaries.share(this.id, form)
                    .then(() => {
                        //console.log(response)

                        this.$store.dispatch('snackbarSuccess', `Se ha compartido correctamente`);
                        this.$router.push({name: 'Questionary'});
                    })
                    .catch((error) => {
                        //console.log(error.response)
                        var errors = []
                        switch(error.response.status){
                            case 400:
                                //console.log(99, error.response);
                                if(("message" in error.response.data)){
                                    Object.keys(error.response.data.message).forEach((x) => {
                                        //console.log(x);
                                        this.serverErrors = error.response.data.message;
                                        error.response.data.message[x].forEach((y) => {
                                            if(x.startsWith('apply_for')){
                                                this.serverErrors['apply_for'] = this.getApplyForMsg(form.apply_for, {key:x, text:y});
                                            }else{
                                                this.serverErrors[x] = Utils.deleteWord(x,y);

                                            }
                                            errors.push(Utils.deleteWord(x,y))
                                        })
                                    });
                                    this.$store.dispatch('snackbarError', errors.join('.<br>'));
                                }

                            break;

                        }
                        console.log(this.serverErrors);
                        this.setErrorClassByServer(this.serverErrors);
                    })
                    .finally(() => {
                        this.saveBtnData.loading = false;
                        this.$store.state.loading = false;
                    })
                ;
            }else{

                this.saveBtnData.loading = false;
                this.$store.state.loading = false;
                this.$store.dispatch('snackbarError', `Formulario inválido`);
            }
            // eslint-disable-next-line no-console
        },


        
        processRequest(request)
        {
            let data = JSON.parse(JSON.stringify(request));


            if (data.employees == null) data.employees = [];
            if (data.apply_for == null) data.apply_for = [];


            //employess list
            //process already added employess
            data.employees = []
            data.apply_for = []
            request.employees.forEach((e) => {
                let found = data.employees.findIndex(
                    (x) => x.id == e.businessId
                );
                if (found == -1 && !found.hasAnswers) {
                    data.employees.push({
                        id: e.businessId,
                        name: e.businessName,
                        employees: [
                            {
                                id: e.id.toString(),
                                email: e.email,
                                name: e.name,
                            },
                        ],
                    });
                } else if(!e.hasAnswers) {
                    data.employees[found].employees.push({
                        id: e.id.toString(),
                        email: e.email,
                        name: e.name,
                    });
                }
            });

            request.businessData.forEach((b) => {
                // console.log(
                //     b.employees.length,
                //     b.selectedBusiness ||
                //         (b.employees.length > 0 &&
                //             b.employees.length == b.employees_notified.length),
                //     "1"
                // );
                if (
                    b.selectedBusiness ||
                    (b.employees.length > 0 &&
                        b.employees.length == b.employees_notified.length)
                ) {
                    //add full business
                    data.apply_for.push({
                        id: b.businessId,
                        name: b.businessName,
                    });
                    
                } else if (b.employees_notified.length > 0) {
                    //some employees

                    b.employees_notified.forEach((e) => {
                        let found = data.employees.findIndex(
                            (x) => x.id == e.businessId
                        );
                        if (found == -1 && !found.hasAnswers) {
                            data.employees.push({
                                id: e.businessId,
                                name: e.businessName,
                                employees: [
                                    {
                                        id: e.id.toString(),
                                        email: e.email,
                                        name: e.name,
                                    },
                                ],
                            });
                        } else if(!e.hasAnswers) {
                            data.employees[found].employees.push({
                                id: e.id.toString(),
                                email: e.email,
                                name: e.name,
                            });
                        }
                    });
                }
            });

            data.apply_for = Utils.removeDuplicatesArrayObject(
                data.apply_for,
                (it) => it.id
            );

            for (let a = 0; a < data.employees.length; a++) {
                data.employees[a].employees = Utils.removeDuplicatesArrayObject(
                    data.employees[a].employees,
                    (it) => it.id
                );
            }


            delete data.businessData;
            let finalData =  {apply_for: data.apply_for, employees: data.employees};
            if(finalData.apply_for.length == 0)
                delete finalData.apply_for;
            if(finalData.employees.length == 0)
                delete finalData.employees;

            return finalData;
        }
    },
}
</script>

<style lang="scss">
    .questionnaire-share{
        &-subtitles{
            line-height: normal !important;
            font-size: 0.8rem;
        }
    }
</style>